import { post } from '../index';

// Platform admin: freeze a customer. Locks every login (and cuts off
// sessions already open) and pauses the company's Stripe subscription.
// body: { reason?: string, pauseBilling?: boolean (default true) }
// Response: { company, billing: { paused: [subIds], customerId, error } }
export const mainAdminSuspendCompany = (companyId, body = {}) => {
  return post(`/admin-panel/companies/${companyId}/suspend`, body);
};
